import {createContext, useContext, useState, useRef} from 'react'
import {arrow, autoUpdate, flip, offset, shift, useFloating, useInteractions, useHover} from '@floating-ui/react'

const TooltipContext = createContext(null)
const {Provider} = TooltipContext

const ARROW_HEIGHT = 8
const GAP = 2

export const TooltipProvider = ({placement = 'top', children, ...rest}) => {
	const arrowRef = useRef(null)

	const [isOpen, setIsOpen] = useState(false)

	const floating = useFloating({
		open: isOpen,
		onOpenChange: setIsOpen,
		placement,
		middleware: [
			offset(ARROW_HEIGHT + GAP),
			flip({
				crossAxis: false,
				fallbackAxisSideDirection: 'start',
				padding: 4,
			}),
			shift({padding: 4}),
			arrow({element: arrowRef}),
		],
		whileElementsMounted: autoUpdate,
	})

	const hover = useHover(floating.context, {
		move: false,
	})

	const interactions = useInteractions([hover])

	const value = {
		isOpen,
		setIsOpen,
		arrowRef,
		...floating,
		...interactions,
		...rest,
	}

	return <Provider value={value}>{children}</Provider>
}

export const useTooltipContext = () => useContext(TooltipContext)
